import React from 'react'
import PropTypes from 'prop-types'
import { compose, pure } from 'recompose'

import './TextField.css'

const TextField = ({ handleChange, placeholder, id }) => {
  return (
    <input
      id={id}
      styleName="textfield"
      type="text"
      placeholder={placeholder}
      onChange={e => handleChange(e.target.value)}
    />
  )
}

TextField.propTypes = {
  handleChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  id: PropTypes.string
}

export default compose(pure)(TextField)
